<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.name"
        placeholder="请输入名称"
        clearable
        size="small"
        class="param-input"
        style="width: 220px"
      ></el-input>
      <el-select
        placeholder="请选择类型"
        clearable
        size="small"
        v-model="params.type"
        @change="getAllLatitude()"
      >
        <el-option
          :label="item.label"
          :value="item.number"
          v-for="item in types"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        clearable
        size="small"
        v-model="params.kind"
        placeholder="请选择种类"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in kinds"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择维度"
        clearable
        size="small"
        v-model="params.dimension"
      >
        <el-option
          :label="item.name"
          :value="item.name"
          v-for="item in latitudes"
          :key="item.name"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择是否激活"
        clearable
        size="small"
        v-model="params.active"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in actives"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" align="center" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.name || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" width="100">
        <template slot-scope="scope">
          <el-tag
            style="background-color: #ecf5ff;color: #409eff;border: 1px solid #d9ecff;"
            v-if="scope.row.type == 1"
            >动漫</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.type == 2">漫画</el-tag>
          <el-tag type="danger" v-else-if="scope.row.type == 3"
            >文本小说</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.type == 4"
            >有声小说</el-tag
          >
          <el-tag type="info" v-else-if="scope.row.type == 5">剧场</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="kind" label="种类" align="center" width="100">
        <template slot-scope="scope">
          <el-tag
            style="background-color: #ecf5ff;color: #409eff;border: 1px solid #d9ecff;"
            v-if="scope.row.kind === 1"
            >哩番</el-tag
          >
          <el-tag type="success" v-else-if="scope.row.kind === 2">3D</el-tag>
          <el-tag type="danger" v-else-if="scope.row.kind === 3"
            >同人动画</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.kind === 4"
            >单行本</el-tag
          >
          <el-tag type="info" v-else-if="scope.row.kind === 5">连载漫画</el-tag>
          <el-tag plain type="success" v-else-if="scope.row.kind === 6"
            >韩漫</el-tag
          >
          <el-tag plain type="danger" v-else-if="scope.row.kind === 7"
            >小说</el-tag
          >
          <el-tag plain type="info" v-else-if="scope.row.kind === 8"
            >剧场</el-tag
          >
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="dimension" label="维度" align="center" width="240">
        <template slot-scope="scope">
          <span>{{ scope.row.dimension || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="active" label="是否激活" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.active">激活</el-tag>
          <el-tag v-else>未激活</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="isDiscovery"
        label="是否推荐发现"
        align="center"
        width="80"
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isDiscovery">是</el-tag>
          <el-tag v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.sort || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAct"
        label="操作人"
        align="center"
        min-width="100"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAct || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updateTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="180"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="280"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          >
          <el-button
            v-if="!scope.row.isDiscovery"
            type="warning"
            size="mini"
            @click="handelDiscovery('add', scope.row)"
            >推送推荐发现</el-button
          >
          <el-button
            v-else
            type="info"
            size="mini"
            @click="handelDiscovery('del', scope.row)"
            >移除推荐发现</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="560px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <el-form-item
          label="名称:"
          size="small"
          prop="name"
          style="width: 480px"
        >
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="类型:"
          prop="type"
          style="width: 480px"
        >
          <el-select
            @change="getAllLatitude()"
            v-model="form.type"
            placeholder="请选择类型"
          >
            <el-option
              :label="item.label"
              :value="item.number"
              v-for="item in types"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          label="种类:"
          prop="kind"
          style="width: 480px"
          v-if="form.type"
        >
          <el-select
            v-model="form.kind"
            placeholder="请选择种类"
          >
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in dialogKinds"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="维度:"
          size="small"
          prop="dimension"
          style="width: 480px"
        >
          <el-select v-model="form.dimension">
            <el-option
              :label="item.name"
              :value="item.name"
              v-for="item in latitudes"
              :key="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          size="small"
          label="排序:"
          prop="sort"
          style="width: 480px"
        >
          <el-input v-model.number="form.sort"></el-input>
        </el-form-item>
        <el-form-item
          size="small"
          label="是否激活:"
          prop="active"
          style="width: 480px"
        >
          <el-select v-model="form.active" placeholder="请选择是否激活">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="item in actives"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import { animeTypes } from "../../../config/anime";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        active: undefined, // 是否激活
        dimension: undefined, // 维度
        name: undefined, // 名称
        type: undefined, // 类型
        kind: undefined, // 种类
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      actives: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      types: animeTypes,
      latitudes: [], // 维度数组
      dialogTitle: "",
      dialogVisible: false,
      form: {
        id: undefined,
        name: undefined, // 名称
        dimension: undefined, // 维度
        sort: 0, // 排序
        type: 1, // 类型 1动漫 2漫画 3小说 4cos 5禁播)
        active: true, // 是否激活
        kind: undefined, // 种类
      },
    };
  },
  computed: {
    kinds() {
      const t = animeTypes.find(v => v.number === this.params.type)
      this.params.kind = null
      if (t) {
        return t.kinds
      }
      return []
    },
    dialogKinds() {
      const t = animeTypes.find(v => v.number === this.form.type)
      this.form.kind = null
      if (t) {
        return t.kinds
      }
      return []
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getAllLatitude() {
      API.getAnimeAllLatitude({
        type: this.form.type,
      })
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.latitudes = res.data.list || [];
          } else {
            this.latitudes = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getAnimeTagList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增播单
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.name = param.name;
        this.form.dimension = param.dimension;
        this.form.sort = param.sort;
        this.form.type = param.type;
        this.form.active = param.active;
        this.form.kind = param.kind;
      }
      this.getAllLatitude();
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addAnimeTag(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.updateAnimeTag(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delAnimeTag(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handelDiscovery(type, row) {
      let req = {
        isDiscovery: false,
        id: row.id,
      };
      if (type === "add") {
        req.isDiscovery = true;
      }
      API.updateAnimeTag(req)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message.error("操作失败");
          }
        })
        .catch(() => {
          this.getList();
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.name = undefined;
      this.form.dimension = undefined;
      this.form.sort = 0;
      this.form.type = 1;
      this.form.active = true;
      this.form.kind = undefined;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}
/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 130px;
}
</style>
